"use client";

import { useEffect, useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Moistureprotectionhero() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="3414" id="moistureprotectionhero" className="bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center">
      {}
      <div className="absolute inset-0 w-full h-[120%] -top-[10%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615668/img/crawl_space_encapsulation_des_moines.png)]" style={{
      transform: `translateY(${scrollY * 0.3}px)`
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(135deg, hsla(160, 72%, 10%, 0.85) 0%, hsla(160, 46%, 20%, 0.65) 50%, hsla(160, 72%, 8%, 0.9) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 30%, hsla(160, 72%, 5%, 0.75) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} aria-hidden="true" />

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-32">
        <div className="max-w-4xl">
          {}
          <div className="font-mono text-xs md:text-sm uppercase mb-8 md:mb-12" style={{
          color: "hsl(160 46% 85%)",
          letterSpacing: "0.2em"
        }}>
            — SERVING DES MOINES & CENTRAL IOWA
          </div>

          {}
          <h1 className="font-default font-bold leading-[0.95] mb-8 md:mb-10" style={{
          fontSize: "clamp(3.5rem, 11vw, 9rem)",
          letterSpacing: "-0.03em",
          color: "hsl(0 0% 100%)"
        }}>
            <span className="block">Dry Home.</span>
            <span className="block">Healthy</span>
            <span className="block italic" style={{
            color: "hsl(160 46% 65%)"
          }}>
              Living.
            </span>
          </h1>

          {}
          <p className="font-default text-lg md:text-xl max-w-xl mb-10 md:mb-12 leading-relaxed" style={{
          color: "hsla(0, 0%, 100%, 0.85)"
        }}>
            Professional crawl space encapsulation and moisture control for Iowa homeowners. Protect your foundation and air quality.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 sm:items-center">
            <Link to="/ContactPage">
              <Button size="lg" className="rounded-md h-12 px-7 font-default font-semibold text-base shadow-lg group" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                Request Free Inspection
                <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>

            <Link to="/ServicesPage">
              <Button variant="outline" size="lg" className="rounded-md h-12 px-7 font-default text-base bg-transparent border hover:bg-white/10" style={{
              borderColor: "hsla(0, 0%, 100%, 0.4)",
              color: "hsl(0 0% 100%)"
            }}>
                <Play className="size-4" />
                Our Process
                <ArrowRight className="ml-1 size-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 md:bottom-12 right-6 md:right-10 lg:right-16 z-10 flex flex-col items-center gap-6">
        <div className="font-mono text-[10px] md:text-xs uppercase hidden md:flex flex-col items-center gap-2" style={{
        color: "hsla(0, 0%, 100%, 0.7)",
        letterSpacing: "0.2em",
        writingMode: "vertical-rl"
      }}>
          <span>LOCAL EXPERTS / DES MOINES</span>
        </div>

        {}
        <div className="relative h-12 w-px overflow-hidden">
          <div className="absolute top-0 left-0 w-px h-4 animate-scroll-line" style={{
          backgroundColor: "hsl(0 0% 100%)"
        }} />
          <div className="absolute inset-0 w-px" style={{
          backgroundColor: "hsla(0, 0%, 100%, 0.2)"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes scroll-line {
          0% {
            transform: translateY(-100%);
          }
          50% {
            transform: translateY(200%);
          }
          100% {
            transform: translateY(-100%);
          }
        }
        .animate-scroll-line {
          animation: scroll-line 2.5s ease-in-out infinite;
        }
      `}</style>
    </section>;
}